"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailButton = exports.emailShareAction = void 0;

var _icons = require("../../assets/icons");

var _sharing_helper = require("../../helpers/sharing_helper");

var _base = require("./base");

var emailShareAction = function emailShareAction(_ref) {
  var shareUrl = _ref.shareUrl,
      _ref$subject = _ref.subject,
      subject = _ref$subject === void 0 ? null : _ref$subject,
      _ref$teaser = _ref.teaser,
      teaser = _ref$teaser === void 0 ? '' : _ref$teaser,
      utmParams = _ref.utmParams;
  var encodedSubject = encodeURIComponent(subject || teaser);
  var encodedBody = (0, _sharing_helper.encodedShareURL)("".concat(teaser, " ").concat(shareUrl), utmParams);
  return window.open("mailto:?subject=".concat(encodedSubject, "&body=").concat(encodedBody), '_self');
};

exports.emailShareAction = emailShareAction;
var EmailButton = (0, _base.buildShareButtonComponent)({
  action: emailShareAction,
  ariaLabel: 'Email',
  className: 'share-button--email',
  icon: _icons.EmailIcon
});
exports.EmailButton = EmailButton;